import { PRODUCTS_URL,UPLOAD_URL } from "../constants";
import { apiSlice } from "./apiSlice";


export const productsApiSlice = apiSlice.injectEndpoints({
    endpoints : (builder) =>({
// frontend/src/slices/productsApiSlice.js
getProducts: builder.query({
  query: ({ keyword, pageNumber, brands, currents }) => ({
    url: PRODUCTS_URL,
    params: {
      keyword,
      pageNumber,
      brands,
      currents, // 🌟 Anma akımları sunucuya taşınır (?currents=40A,16A)
    },
  }),
  keepUnusedDataFor: 5,
  providesTags: ['Products'],
}),

        getProductDetails: builder.query({
          query: (productId) => ({
            url: `${PRODUCTS_URL}/${productId}`,
          }),
          keepUnusedDataFor: 5,
        }),
        createProduct: builder.mutation({
          query: () => ({
            url:PRODUCTS_URL,
            method: 'POST',
          }),
          invalidatesTags : ['Product'],
       
        }),
        updateProduct: builder.mutation({
          query: (data)=> ({
            url: `${PRODUCTS_URL}/${data.productId}`,
            method: 'PUT',
            body: data,
          }),
          invalidatesTags: ['Products'],
        }),
        uploadProductImage: builder.mutation({
          query: (data)=> ({
            url: `${UPLOAD_URL}`,
            method: 'POST',
            body: data,
          })
        }),
        deleteProduct: builder.mutation({
          query: (productId) => ({
            url: `${PRODUCTS_URL}/${productId}`,
            method: 'DELETE',
          })
      }),
      createReview: builder.mutation({
        query: (data) => ({
          url:`${PRODUCTS_URL}/${data.productId}/reviews`,
          method: 'POST',
          body: data,
        }),
        invalidatesTags: ['Product'],

      }),

      getTopProducts : builder.query({
        query: () => ({
            url: `${PRODUCTS_URL}/top`,

        }),

        keepUnusedDataFor:5,
    }),

    // 🌟 Filtre panelindeki (Markalar / Anma Akımı) seçenekler artık sadece o anki 12
    // ürünlük sayfadan değil, keyword'e uyan TÜM ürünlerden geliyor.
    getProductFilters: builder.query({
        query: ({ keyword }) => ({
            url: `${PRODUCTS_URL}/filters`,
            params: { keyword },
        }),
        keepUnusedDataFor: 5,
        providesTags: ['Products'],
    }),

    }),
    
});

export const{useGetProductsQuery,useGetProductDetailsQuery,useCreateProductMutation,useUpdateProductMutation,useUploadProductImageMutation,useGetTopProductsQuery,useDeleteProductMutation,useCreateReviewMutation,useGetProductFiltersQuery} = productsApiSlice;